import { Navigate } from 'react-router-dom'

import useCustomPeriodPath from 'modules/attendance/lib/useCustomPeriodPath'

const NavigateToCustomPeriodExportsPage = () => {
  const to = useCustomPeriodPath()

  return <Navigate replace to={to} />
}

export default NavigateToCustomPeriodExportsPage
